import {ACTION_CODE} from './_actionCode';
import {ExpenseService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'UPDATE_EXPENSE';

export async function updateDealExpense(userData: Record<string, any>, expenseId: string, payloadExpense: any) {
    try {
        LoggerService.logInfo('Action - createExpense - Start');

        const updateExpenseResult = await ExpenseService.updateExpense(userData, expenseId, payloadExpense);

        LoggerService.logInfo('Action - createExpense - End - Success');

        return ResultModel.newSuccessResult(updateExpenseResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - createExpense - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
